/**
 * HTML attributes that discourage browser autofill and password-manager
 * suggestions on non-credential fields (search, numeric tool inputs, etc.).
 *
 * Add new vendor-specific keys here when additional password managers need
 * explicit opt-out.
 */
export const PASSWORD_MANAGER_IGNORE_ATTRS = {
  autocomplete: 'off',
  'data-lpignore': 'true',
  'data-1p-ignore': 'true',
  'data-form-type': 'other',
  'data-bwignore': 'true',
  'data-dashlane-ignore': 'true'
} as const satisfies Record<string, string>;

export type PasswordManagerIgnoreAttrs = typeof PASSWORD_MANAGER_IGNORE_ATTRS;
